import { useMutation } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { CompositionsService } from '../../services/CompositionsService';
import { AddCanvasForm } from './-AddCanvasForm';
import { Button } from '@streamelements/frontend-ui';
import { openVideoCompositionDockingWidget } from '../../utils/dockingWidgets';

export const Route = createFileRoute('/_authenticated/canvases/new')({
  component: CreateNewCanvas,
});

function CreateNewCanvas() {
  const submitMutation = useMutation({
    mutationFn: async (data: { canvasName: string; videoFrame: { width: number; height: number } }) => {
      const videoComposition = await CompositionsService.createVideoComposition({
        videoCompositionName: data.canvasName,
        videoFrame: data.videoFrame,
      });
      await openVideoCompositionDockingWidget({
        videoCompositionId: videoComposition.id,
      });
      return videoComposition;
    },
    onSuccess: (videoComposition) => {
      window.host.endModalDialog(videoComposition, () => void 0);
    },
    onError: console.log,
  });

  return (
    <AddCanvasForm onSubmit={(values) => submitMutation.mutate(values)}>
      {({ formState }) => (
        <>
          <Button
            type="button"
            variant="ghost"
            disabled={submitMutation.isPending}
            density="compact"
            onClick={() => window.host.endModalDialog(null, () => void 0)}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={!formState.isValid || submitMutation.isPending} density="compact">
            {submitMutation.isPending ? 'Setting everything up...' : 'Add'}
          </Button>
        </>
      )}
    </AddCanvasForm>
  );
}
